import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { Route } from 'react-router-dom';
import { TopBar } from './components';
import {
    Window,
    Consumption,
    Performance,
    PerformanceByUsers,
    List,
    Groups,
    Total,
    TimeWaitGroup,
    Categories,
    ServiceTime,
    ServiceGroupsTimeWait,
    Holidays,
    PeakAttendance,
    VideoCall,
    ViewTutorials,
    ArchivedTutorialsPage
} from './pages';
import './App.css';
import { Aside } from './components';
import { useAuth } from './contexts/auth';
const keyUsernameStorage = '@UCB-Username';

export function App(props) {

    const {
        idUser,
        searchUserLogged,
        companiesUser
    } = useAuth();

    const [asideOpen, setAsideOpen] = useState(false);
    const [userLogged, setUserLogged] = useState(null);
    const [companies, setCompanies] = useState([]);

    const loadInfUserSystem = useCallback(async () => {
        const [response1, response2] = await Promise.all([
            searchUserLogged(),
            companiesUser()
        ]);
        setUserLogged(response1)
        sessionStorage.setItem(keyUsernameStorage, response1?.nomecompleto ?? "")
        setCompanies(response2)
    }, []);
    useEffect(() => {
        if (idUser) {
            loadInfUserSystem();
        }
    }, []);

    const router = [
        { path: '/window', component: Window, exact: true, meta: { breadcrumb: [{ parent: '', label: 'Chat' }] } },
        { path: '/reports/charts/consumption', component: Consumption, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/charts/service-time', component: ServiceTime, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/charts/service-time-groups', component: ServiceGroupsTimeWait, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/charts/performance', component: Performance, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/charts/performance-users', component: PerformanceByUsers, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/charts/peakattendance', component: PeakAttendance, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/teleservice/videocall', component: VideoCall, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/admin/registers/list', component: List, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/admin/registers/groups', component: Groups, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/admin/registers/holidays', component: Holidays, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        // { path: '/reports/users/status', component: Status, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/customer-service/total', component: Total, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/reports/customer-service/time-wait-group', component: TimeWaitGroup, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/admin/comments/categories', component: Categories, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/admin/tutorials/viewtutorials', component: ViewTutorials, exact: true, meta: { breadcrumb: [{ parent: '', label: '' }] } },
        { path: '/archived-tutorials', component: ArchivedTutorialsPage, exact: true, meta: { breadcrumb: [{ parent: '', label: 'Tutoriais Arquivados' }] } },
        { path: '/', exact: true, meta: { breadcrumb: [{ parent: 'Login', label: 'Login' }] } },
    ];

    const containerClassName = classNames('layout-wrapper',
        {
            'layout-static': true,
            'layout-static-inactive': asideOpen,
        }
    );

    return (
        <div
            className={containerClassName}
        >
            <div className="layout-content-wrapper">
                <TopBar
                    userLogged={userLogged}
                    companiesUser={companies}
                    handOpenAside={() => setAsideOpen(!asideOpen)}
                    isOpenAside={asideOpen}
                />
                <div className="layout-content">
                    {
                        router.map((router, index) => {
                            if (router.exact) {
                                return <Route
                                    key={`router${index}`}
                                    path={router.path}
                                    exact
                                    component={router.component}
                                />
                            }
                            return <Route
                                key={`router${index}`}
                                path={router.path}
                                component={router.component}
                            />
                        })
                    }
                </div>
            </div>
            <div className="layout-sidebar">
                <Aside />
            </div>
        </div>

    );
};